import { useEffect, useState } from "react";
import { apiUrl, authToken } from "../api";

interface State {
  src: string | null;
  loading: boolean;
  error: string | null;
}

export function useAuthedImage(path: string | null): State {
  const [state, setState] = useState<State>({
    src: null,
    loading: !!path,
    error: null,
  });

  useEffect(() => {
    if (!path) {
      setState({ src: null, loading: false, error: null });
      return;
    }
    let cancelled = false;
    let objectUrl: string | null = null;

    setState({ src: null, loading: true, error: null });

    (async () => {
      try {
        const t = authToken();
        const r = await fetch(apiUrl(path), {
          headers: t ? { Authorization: `Bearer ${t}` } : {},
        });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const blob = await r.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setState({ src: objectUrl, loading: false, error: null });
      } catch (e) {
        if (!cancelled)
          setState({
            src: null,
            loading: false,
            error: (e as Error).message,
          });
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  return state;
}
